export const FETCH_DASHBOARDS_SUCCESS = "FETCH_DASHBOARDS_SUCCESS";
export const POST_DASHBOARDS_SUCCESS = "POST_DASHBOARDS_SUCCESS";
export const FETCH_DASHBOARDS_SP_SUCCESS = "FETCH_DASHBOARDS_SP_SUCCESS";
export const FETCH_DASHBOARDS_LB_SUCCESS = "FETCH_DASHBOARDS_LB_SUCCESS";
export const CHANGE_TYPE_LIST_DASHBOARD_SUCCESS = "CHANGE_TYPE_LIST_DASHBOARD_SUCCESS";
